// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBusinessWindfarmSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m14.353 1.82-2.291 7.097 2.755 6.868c.207.518-.461.935-.835.521l-4.948-5.475-7.412-1.06c-.553-.08-.58-.867-.034-.984l7.29-1.564 4.606-5.865c.345-.439 1.04-.068.87.463zM11 20h1.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H9v-7.715l2 2.213zm6.034-9.169-3.317-.474-.592-1.476.295-.916 3.459-.742 4.605-5.865c.345-.439 1.04-.068.87.463l-2.292 7.096 2.755 6.868c.207.518-.461.935-.835.521zM19 20h1.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H17v-7.715l2 2.213z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBusinessWindfarmSolid;
